export default "__VITE_ASSET__CPQhOumO__"